export default {
  STATE_TOKEN_KEY_NAME: 'ghtkStateToken',
  DEFAULT_POLLING_DELAY: 500,
  DEFAULT_MAX_CLOCK_SKEW: 300,
  DEFAULT_CACHE_DURATION: 86400,
  REDIRECT_OAUTH_PARAMS_COOKIE_NAME: 'ghtk-oauth-params',
  TOKEN_STORAGE_NAME: 'ghtk-token-storage',
  CACHE_STORAGE_NAME: 'ghtk-cache-storage',
  PKCE_STORAGE_NAME: 'ghtk-pkce-storage',
  AUTHN_STATE_STORAGE_NAME: 'ghtk-authn-state-storage',
  SIGNED_IN_STORAGE_NAME: 'signed-in-storage',
  TRANSACTION_STATUS: {
    // PUBLIC: 'public',
    // AUTHN_UNKNOWN: 'authn_unknown',
    // AUTHN_SERVER_ERROR: 'authn_server_error',
    // AUTHN_SUCCESS: 'authn_success',
    // AUTHN_FAIL: 'authn_fail',
    // AUTHN_MFA_REQUIRED: 'authn_mfa_required',
    // AUTHN_MFA_CHALLENGE: 'authn_mfa_challenge',
    // AUTHN_PASSWORD_EXPIRED: 'authn_password_expired',
    // RECOVERY_CHALLENGE: 'recovery_challenge',
    // RECOVERY_CHALLENGE_FAIL: 'recovery_challenge_fail',
    // RECOVERY: 'recovery',
    // RECOVERY_FAIL: 'recovery_fail',
    // PASSWORD_RESET: 'password_reset',
    // PASSWORD_RESET_FAIL: 'password_reset_fail',
    // INVALID_AUTHN_TOKEN: 'invalid_authn_token',
    // INVALID_RECOVERY_TOKEN: 'invalid_recovery_token',
    // INVALID_PASSCODE: 'invalid_passcode',
    // REQUIRE_CAPTCHA: 'require_captcha',
    // INVALID_CAPTCHA: 'invalid_captcha',
  },
  STATE: {
    UNKNOWN: 'unknown',
    UNKNOWN_AUTHN_STATE: 'unknown:authn_state',
    UNKNOWN_ERROR_STATE: 'unknown:error_state',
    REQUIRE_CAPTCHA: 'require_captcha',
    AUTHN: {
      SUCCESS: 'authn_state:success',
      MFA_REQUIRED: 'authn_state:mfa_required',
      MFA_CHALLENGE: 'authn_state:mfa_challenge',
      MFA_ENROLL: 'authn_state:mfa_enroll',
      MFA_ENROLL_ACTIVE: 'authn_state:mfa_enroll_active',
      RECOVERY: 'authn_state:recovery',
      RECOVERY_CHALLENGE: 'authn_state:recovery_challenge',
      PASSWORD_RESET: 'authn_state:password_reset',
      PASSWORD_EXPIRED: 'authn_state:password_expired',
      UNAUTHENTICATED: 'authn_state:unauthenticated'
    },
    ERROR: {
      CLIENT: {
        INVALID_API_CONDITION: 'error_state:400:invalid_api_condition',
        ILLEGAL_REQUEST_PARAM: 'error_state:400:illegal_request_param',
        ILLEGAL_REQUEST: 'error_state:400:illegal_request',
        INVALID_CAPTCHA: 'error_state:400:invalid_captcha',
        RESOURCE_DUPLICATED: 'error_state:400:resource_duplicated',
        EXCEED_SECONDARY_CONTACT_LIMIT: 'error_state:400:exceed_secondary_contact_limit',
        AUTHN_FAIL: 'error_state:401:authn_fail',
        PASSWORD_EXPIRED: 'error_state:401:password_expired',
        LOGIN_REQUIRED: 'error_state:401:login_required',
        CONSENT_REQUIRED: 'error_state:401:consent_required',
        INVALID_TOKEN: 'error_state:401:invalid_token',
        INVALID_AUTHZ_CODE: 'error_state:401:invalid_authz_code',
        INVALID_PKCE_CODE: 'error_state:401:invalid_pkce_code',
        INVALID_RECOVERY_TOKEN: 'error_state:401:invalid_recovery_token',
        INVALID_REFRESH_TOKEN: 'error_state:401:invalid_refresh_token',
        PERMISSION_DENIED: 'error_state:403:permission_denied',
        EXCEED_SESSION_LIMIT: 'error_state:403:exceed_session_limit',
        PASSWORD_POLICY_VIOLATION: 'error_state:403:password_policy_violation',
        SECURITY_POLICY_VIOLATION: 'error_state:403:security_policy_violation',
        INVALID_SESSION: 'error_state:403:invalid_session',
        INVALID_AUTHN_TOKEN: 'error_state:403:invalid_authn_token',
        ILLEGAL_AUTHN_STATE: 'error_state:403:illegal_authn_state',
        INVALID_PASSCODE: 'error_state:403:invalid_passcode',
        INVALID_CLIENT: 'error_state:403:invalid_client',
        INVALID_TEMP_ACCESS_CODE: 'error_state:403:invalid_temp_access_code',
        EXCEED_DIRECT_TOKEN_LIMIT: 'error_state:403:exceed_direct_token_limit',
        EXCEED_TEMP_ACCESS_LIMIT: 'error_state:403:exceed_temp_access_limit',
        RESOURCE_NOT_FOUND: 'error_state:404:resource_not_found',
        EMAIL_TOO_MANY_REQUEST: 'error_state:429:email_too_many_request',
        SMS_TOO_MANY_REQUEST: 'error_state:429:sms_too_many_request',
        TOO_MANY_REQUEST: 'error_state:429:too_many_request'
      },
      SERVER: {
        INTERNAL_ERROR: 'error_state:500:internal_error',
        NOTIFY_SMS_FAIL: 'error_state:500:notify_sms_fail',
        NOTIFY_EMAIL_FAIL: 'error_state:500:notify_email_fail',
        BAD_GATEWAY: 'error_state:502:bad_gateway',
        SERVICE_UNAVAILABLE: 'error_state:503:service_unavailable',
        GATEWAY_TIMEOUT: 'error_state:504:gateway_timeout'
      }
    }
  }
}
